import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Facebook, Instagram, Music2 } from 'lucide-react';
import { contactInfo } from '../../data/mockData';

const WhoWeAre = () => {
  return (
    <section className="py-24 bg-[#FAF6F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <span className="inline-block px-3 py-1 rounded-full bg-[#2D5016]/10 text-[#2D5016] text-xs font-semibold uppercase tracking-wider mb-4">
              Who We Are
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3B2F1E] mb-6 leading-tight">
              Nourishing Communities Through Responsible Farming
            </h2>
            <div className="space-y-4 text-[#3B2F1E]/80 leading-relaxed">
              <p>
                At Good Grains, we believe healthy animals start with honest feed. From backyard flocks to full-size farms, we provide Non-GMO and Organic feed to help your animals grow strong and thrive, all with simple, reliable service you can count on.
              </p>
              <p>
                Whether you're feeding chickens, goats, cattle, pigs, or other livestock, we're here to support your animals and your homestead with feed you can trust. Robert Norton, a lifelong homesteader and livestock caretaker, built Good Grains from his own farm experience and deep respect for the land and animals. After years of feeding his own animals and helping neighbors, he started Good Grains so homesteaders and farms, big or small, could have dependable feed and support they can rely on.
              </p>
              <p>
                We're proud to be part of the Montana farming and homesteading community, and we're here to help you feed your animals with confidence.
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 text-[#2D5016] font-semibold hover:gap-3 transition-all duration-300 group"
              >
                About Us
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              
              <div className="flex items-center gap-3">
                <a
                  href={contactInfo.social.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#3B2F1E]/10 flex items-center justify-center hover:bg-[#2D5016] hover:text-white transition-all duration-300"
                >
                  <Music2 className="w-5 h-5" />
                </a>
                <a
                  href={contactInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#3B2F1E]/10 flex items-center justify-center hover:bg-[#2D5016] hover:text-white transition-all duration-300"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href={contactInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#3B2F1E]/10 flex items-center justify-center hover:bg-[#2D5016] hover:text-white transition-all duration-300"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=800&auto=format&fit=crop&q=80"
                alt="Pastoral farm scene with livestock"
                className="w-full h-[500px] object-cover rounded-2xl shadow-2xl"
              />
              {/* Decorative Frame */}
              <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-[#D4A84B] rounded-2xl -z-10" />
            </div>
            {/* Stats Card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-xl shadow-xl p-6">
              <p className="text-[#D4A84B] font-serif text-4xl font-bold">5+</p>
              <p className="text-[#3B2F1E]/70 text-sm">Years of Feed Excellence</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
